import React, { useEffect, useState } from 'react';
import Header from '../../Components/Header';
import { FaSearch } from "react-icons/fa";
import MaterialTable from '../../Components/Table/MaterialTable';
import { tableEye } from '../../common/Assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import { get } from '../../Services/ApiHandler';
import { URLS } from '../../Services/Constant';

const Transport = () => {

    const navigation = useNavigate();
   

    const [adminList,setAdminList] =useState([]);
    const [search,setSearch]=useState("");
    const[pagination,setPagination]=useState(1);
    const[loader,setLoader]=useState(false);
    const getList = async(src,page) =>{
        try {
            setLoader(true);
            const response = await get(`${URLS.TRANSPORT_LIST}?search=${src}&page=${page}`)
            // const response =await get(`${URLS.TRANSPORT_LIST}`)
            console.log("response",response)
            if(response?.status === "success"){
            setAdminList(response?.data);
            setLoader(false)
            }
            
        }
        catch(error){
            console.log("error",error);
            setLoader(false);
        }

    }

    const pageSize = 10;

    const columns = [
        {
           header: "S.No",
        //    accessorFn: (row, index) => index + 1,
             accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
           id: "serial_no",
        },
        {
            accessorKey: "transport_code",
            header: "Transport ID",
        },
        {
            accessorKey: "transport_name",
            header: "Transport Name",
        },
        {
            accessorKey: "owner_name",
            header: "Owner Name",
        },
        {
            accessorKey: "mobile",
            header: "Mobile Number",
        },
        {
            id: "action", // ✅ important when no accessorKey
            header: "Action",
            Cell: ({ row }) => (
                <div onClick={() => {navigation('/view-transport',
                    {
                        state : {
                            datas:row.original,
                            type: "view"}
                    }
                );
                console.log('transport_id', row.original?.id);
                
                localStorage.setItem('transport_id', row.original?.id);
                }}>
                    <img src={tableEye} alt="" className='tableeye' />
                </div>
            ),
        },
    ];

useEffect(()=>{
getList(search,pagination);
},[search,pagination])



    return (
        <div>
            <Header title={"Transport Management"} />

            <div className="container-fluid main-container">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

                    {/* LEFT TITLE */}
                    <h3 className="m-0 fw-bold fs-5 text-black">Transport Management</h3>

                    {/* RIGHT SECTION */}
                    <div className="d-flex align-items-center gap-3">

                        {/* SEARCH BOX */}
                        <div className="search-box d-flex align-items-center px-3">
                            <input
                                type="text"
                                placeholder="Search "
                                className="border-0 outline-none bg-transparent"
                                value={search}
                                onChange={(e)=>setSearch(e.target.value)}
                            />
                            <div className="ms-2 searchdote" >|</div>
                            <FaSearch color='#7A52AB' className="ms-1" />
                        </div>

                        {/* ADD BUTTON */}
                        <button onClick={() => navigation('/add-transport')} style={{ backgroundColor: "#F98425" }} className="btn text-white fw-semibold px-4 py-2">
                            +Add Transport
                        </button>

                    </div>

                </div>
                <MaterialTable columns={columns}
                 data={adminList || []}
                 pagination={pagination}
                 setPagination={setPagination}
                 loading={loader} />
            </div>
        </div>
    );
};

export default Transport;
